module.exports = __webpack_public_path__ + "static/media/red-ok.7b11f6cd.png";